import { CardStack } from '../card-stack';
import { PaperSize } from '../../../../shared/paper-size';
import { Orientation } from '../../../../enum/dto/orientation.enum';

export abstract class BusinessCardStack extends CardStack {
  getCardHeightInInches(): number {
    return 1.6738;
  }

  getCardWidthInInches(): number {
    return 3;
  }

  nCardsPerPage(paperSize: PaperSize, isOnPerforatedPaper: boolean): number {
    return 8;
  }

  nColumns(): number {
    return 2;
  }

  nRows(): number {
    return 4;
  }

  cardOrientationOnPortraitPage(): Orientation {
    return Orientation.Landscape;
  }
}
